import Blue from "~/core";

new Blue({
	name: 'Sidebar Nav Mobile Accordion',
	selector: ".page-sidebar__mobile",
	setup(container) {
		const trigger = container.querySelector(".page-sidebar__mobile-toggle");
		const content = container.querySelector(".conference-nav, .header-side");
		const breakpoint = 768;

		if (!!trigger && !!content) {
			let config = {
				container,
				trigger,
				content,
				breakpoint
			}
			let t = new this.$toggle(config);
	
			let windowWidth = window.innerWidth;
			this.$addEvents(window, "resize", () => {
				let newWindowWidth = window.innerWidth;
				if (windowWidth !== newWindowWidth && newWindowWidth >= 769) t.close();
				windowWidth = newWindowWidth;
			});
		}

	}
});